import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from '@app/shared/services/settings/settings.service';
import { BehaviorSubject } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-downgrade-airbnb',
  templateUrl: './downgrade-airbnb.component.html',
  styleUrls: ['./downgrade-airbnb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DowngradeAirbnbComponent implements OnInit {
  public loading$ = new BehaviorSubject<boolean>(false);
  public redirect = this.activeRoute.snapshot.queryParams.redirect === 'true';
  public loadingProperties$ = new BehaviorSubject<boolean>(true);

  public affectedProperties$ = this.activeRoute.params.pipe(
    filter((params) => !!params.channelId),
    switchMap((params) => this.settingsService.propertiesAffectedByDowngrade(params.channelId)),
    tap(() => this.loadingProperties$.next(false))
  );

  constructor(
    private readonly settingsService: SettingsService,
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  public async downgrade(): Promise<void> {
    this.loading$.next(true);
    const channelId = this.activeRoute.snapshot.params.channelId;

    try {
      await this.settingsService.downgrade(channelId).toPromise();
      await this.router.navigate(['/accounts']);
    } catch (e) {
      this.loading$.next(false);
    }
  }
}
